import { Checkbox, Modal, Table, Tooltip } from "antd";
import React, { useState } from "react";
// import Pagination from "../../../../Shared/Pagination";
import rpmService from "../../../../Services/rpmService";
import { convertUTCDate } from "../../../../utils/convertionFunc";
import { useDispatch } from "react-redux";
import { fetchRpmDevicesList } from "../../../../Redux/actions/rpmActions";

function DeviceSetUpTable({ data, currentPage, setCurrentPage, totalPages }) {
  const [actInactiveMod, setActInactiveMod] = useState(false);
  const [selectedDevice, setSelectedDevice] = useState(null);
  const [loader, setLoader] = useState(false);
  const dispatch = useDispatch();
  const loggedUserObj = localStorage.getItem("login_result");
  const loggedUser = loggedUserObj ? JSON.parse(loggedUserObj) : null;

  const columns = [
    {
      title: "Code",
      dataIndex: "code",
      key: "code",
      sorter: (a, b) => (a.code ? a.code.localeCompare(b.code) : ""),
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => (a.name ? a.name.localeCompare(b.name) : ""),
    },
    {
      title: "Brand",
      dataIndex: "brand",
      key: "brand",
      sorter: (a, b) => (a.brand ? a.brand.localeCompare(b.brand) : ""),
    },
    {
      title: "Model",
      dataIndex: "model",
      key: "model",
      sorter: (a, b) => (a.model ? a.model.localeCompare(b.model) : ""),
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      sorter: (a, b) =>
        a.description ? a.description.localeCompare(b.description) : "",
    },
    {
      title: "Active/Inactive",
      dataIndex: "isActive",
      key: "isActive",
      render: (_, record) => (
        <Checkbox
          onClick={() => handleStatusChange(record, "open")}
          className="checkbox-green"
          checked={record.status === 1}
        />
      ),
    },
  ];

  const handleDevActInactive = async () => {
    setLoader(true);
    const payload = {
      id: selectedDevice.id,
      modifiedBy: loggedUser?.user?.userId,
      modifiedDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
      status: 0,
    };
    try {
      await rpmService.deviceActiveInactive(payload);
      handleStatusChange(null, "close");
      setLoader(false);
      dispatch(fetchRpmDevicesList({ status: 1 }));
    } catch (e) {
      setLoader(false);
      console.error(e);
    }
  };

  const handleStatusChange = (device, action) => {
    if (action === "open") {
      setActInactiveMod(true);
      setSelectedDevice(device);
    } else if (action === "close") {
      setActInactiveMod(false);
      setSelectedDevice(null);
    }
  };

  return (
    <>
      {/* <div>
                <div className={`min-w-full ${data ? 'w-max' : 'flex-1'} rounded-lg flex justify-center py-2`}>
                    <table className={`w-full mx-2 overflow-scroll relative`}>
                        <thead className='sticky top-0 bg-white z-10'>
                            <tr>
                                <th>Code</th>
                                <th>Name</th>
                                <th>Brand</th>
                                <th>Model</th>
                                <th>Description</th>
                                <th>Active/Inactive</th>
                            </tr>
                            <tr className="bg-[#DEF3F2]">
                                <td className='py-0.5' colSpan={12}></td>
                            </tr>
                        </thead>
                        <tbody className='text-center'>
                            {
                                data?.map((item, idx) => (
                                    <React.Fragment key={idx}>
                                        <tr>
                                            <td>{item.code}</td>
                                            <td>{item.name}</td>
                                            <td>{item.brand}</td>
                                            <td>{item.model}</td>
                                            <Tooltip title={item.description}>
                                                <td className="max-w-[8rem] truncate text-ellipsis overflow-hidden whitespace-nowrap">
                                                    {item.description}
                                                </td>
                                            </Tooltip>
                                            <td>
                                                <Checkbox className="checkbox-green" onClick={() => handleStatusChange(item, 'open')} checked={item.status === 1} />
                                            </td>
                                        </tr>
                                        <tr className="bg-[#DEF3F2]">
                                            <td className='py-0.5' colSpan={12}></td>
                                        </tr>
                                    </React.Fragment>
                                ))
                            }
                        </tbody>
                    </table>
                </div>

                <div className="absolute -bottom-32 right-8 flex justify-end my-2">
                    <Pagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={(page) => setCurrentPage(page)}
                        containerClassName="mb-4"
                        buttonClassName="border border-gray-300 md:px-3 px-2 rounded-full md:py-1 py-0.5 transition duration-300 ease-in-out focus:outline-none hover:bg-[#787878]"
                        activeButtonClassName="bg-brand-primaryColor rounded-full text-white"
                    />
                </div>
            </div> */}

      <Table
        dataSource={data}
        columns={columns}
        //   rowSelection={rowSelection}
        pagination={{
          style: {
            display: "flex",
            justifyContent: "center",
          },
        }}
      />

      {/* Active/ Inactive confirmation modal */}
      <Modal
        open={actInactiveMod}
        onCancel={() => handleStatusChange(null, "close")}
        footer={[]}
        destroyOnClose
        title="Confirmation"
      >
        <div>
          <p>Are you sure you want to change the status</p>
          <div className="w-full flex justify-end items-center mt-3">
            <button
              onClick={() => handleStatusChange(null, "close")}
              className="mx-1 p-1 w-24 border rounded-md border-brand-primaryColor text-brand-primaryColor"
            >
              Cancel
            </button>
            <button
              disabled={loader}
              onClick={handleDevActInactive}
              className="mx-1 p-1 w-24 font-semibold bg-brand-primaryColor text-brand-White rounded-md disabled:cursor-not-allowed disabled:opacity-50"
            >
              Ok
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default DeviceSetUpTable;
